(function(module) {
    'use strict';

    module.service('TimeZone', function(LGTimeZones, SSTimeZones, BrightSignTimeZones) {
        const all = moment.tz.names();
        const ss = _(SSTimeZones)
            .filter(i => all.includes(i.zone))
            .filter(i => !i.zone.includes('Etc/') && !i.zone.includes('Universal'))
            .map(({ zone: value, cities: label }) => ({ value, label: label.replace(/,/g, ', ') }))
            .value();

        const lg = _(LGTimeZones)
            .map(({ city, continent }) => ({ value: `${continent}/${city}`, label: `${continent}/${city}` }))
            .filter(i => all.includes(i.value))
            .sortBy('value')
            .value();

        const brightsign = _(BrightSignTimeZones)
            .sortBy('value')
            .value();

        return {
            getList(device) {
                if (!device) return [];
                switch (device.toLowerCase()) {
                    case 'webos':
                        return lg;
                    case 'tizen':
                        return ss;
                    case 'brightsign':
                        return brightsign;
                    default:
                        return [];
                }
            },
        };
    });
})(angular.module('rocket.components'));

